import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from "prop-types";
import { Table, Badge, Button, Accordion, Card, Row, Col, Pagination } from 'react-bootstrap';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import AddUsers from './PopUps/Add/AddUsers';
import EditUsers from './PopUps/Edit/EditUsers';
import * as Icon from 'react-feather';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

// class NewUsers extends React.Component {
function NewUsers(props) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [expandedUser, setExpandedUser] = useState(null);
    const [userToDeactivate, setUserToDeactivate] = useState(null);
    const [deactivatingUser, setDeactivatingUser] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const apiUrl = process.env.REACT_APP_URL;
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();
    const currentUser = authUser();
    const canRead = canPageAction(currentUser, 'users.users', 'read');
    const canWrite = canPageAction(currentUser, 'users.users', 'write');
    const canDelete = canPageAction(currentUser, 'users.users', 'delete');

    const get_all_users = () => {
        setLoading(true);
        setError('');

        axios({
            method: 'GET',
            url: apiUrl + '/users/get_all_users?user_type=all',
            headers: {
                Authorization: authHeader()
            }
        }).then(response => {
            setData(response.data.msg.Users);
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
            console.log('Error fetching users:', error);

            if (error.response) {
                if (error.response.status === 401) {
                    setError('Authentication required. Please login again.');
                } else if (error.response.status === 422) {
                    setError('Invalid or expired token. Please login again.');
                } else {
                    setError('Failed to load users. Please try again.');
                }
            } else {
                setError('Network error. Please check your connection.');
            }
        });
    }

    useEffect(() => {
        get_all_users();
    }, []);

    const toggleUserDetails = (userId) => {
        setExpandedUser(expandedUser === userId ? null : userId);
    };

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const deleteUser = (user) => {
        if (!user) {
            return;
        }

        setDeactivatingUser(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/users/delete?user_type=all',
            headers: {
                Authorization: authHeader()
            },
            data: { id: user.id }
        }).then(() => {
            setUserToDeactivate(null);
            get_all_users();
        }).catch(error => {
            console.log('Error deleting user:', error);
            setError('Failed to delete user. Please try again.');
        }).finally(() => {
            setDeactivatingUser(false);
        });
    };

    // Generate pagination items
    const getPaginationItems = () => {
        const items = [];
        const maxVisible = 5;

        // Always show first page
        if (totalPages > 1) {
            items.push(
                <Pagination.Item
                    key={1}
                    active={1 === currentPage}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Show ellipsis if needed before current range
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="start-ellipsis" />);
        }

        // Show pages around current page
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let page = startPage; page <= endPage; page++) {
            if (page !== 1 && page !== totalPages) {
                items.push(
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </Pagination.Item>
                );
            }
        }

        // Show ellipsis if needed after current range
        if (currentPage < totalPages - 2) {
            items.push(<Pagination.Ellipsis key="end-ellipsis" />);
        }

        // Always show last page if more than one page
        if (totalPages > 1) {
            items.push(
                <Pagination.Item
                    key={totalPages}
                    active={totalPages === currentPage}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

        return (
            <>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="card-header d-flex justify-content-between">
                        <h5 className="card-title">Usuarios</h5>
                        {canWrite && <AddUsers setData={get_all_users}/>}
                    </div>

                    {error && (
                        <div className="alert alert-danger m-3">
                            {error}
                            <button
                                className="btn btn-sm btn-outline-danger ms-2"
                                onClick={get_all_users}
                            >
                                Retry
                            </button>
                        </div>
                    )}

                    {/* <div className="height-310"> */}
                    <div>
                        {loading && (
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                        <Table className="m-0" responsive>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Email</th>
                                    <th>Teléfono</th>
                                    <th>Rol</th>
                                    <th>Salario Base</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                            {currentItems.map(user => (
                                <React.Fragment key={user.id}>
                                    <tr>
                                        <td>{user.first_name} {user.last_name}</td>
                                        <td>{user.email}</td>
                                        <td>{user.phone_number}</td>
                                        <td>
                                            {user.roles && user.roles.length > 0 ? (
                                                <Badge bg="info">{user.roles.length} {user.roles.length === 1 ? 'Rol' : 'Roles'}</Badge>
                                            ) : (
                                                user.role_name || 'N/A'
                                            )}
                                        </td>
                                        <td>${user.salary}</td>
                                        <td>
                                            <div className="d-flex gap-1">
                                                {canRead && (
                                                    <Button
                                                        size="sm"
                                                        variant="outline-primary"
                                                        onClick={() => toggleUserDetails(user.id)}
                                                    >
                                                        <Icon.Eye size={14} />
                                                    </Button>
                                                )}
                                                {canWrite && <EditUsers setData={get_all_users} user={user}/>}
                                                {canDelete && (
                                                    <Button
                                                        size="sm"
                                                        variant="outline-danger"
                                                        onClick={() => setUserToDeactivate(user)}
                                                    >
                                                        <Icon.Trash2 size={14} />
                                                    </Button>
                                                )}
                                                {!canRead && !canWrite && !canDelete && (
                                                    <span className="text-muted">N/A</span>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    {expandedUser === user.id && (
                                        <tr>
                                            <td colSpan="7">
                                                <div className="p-3 bg-light">
                                                    <h6>Detalles del Usuario</h6>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <p><strong>Nombre Completo:</strong> {user.first_name} {user.last_name}</p>
                                                            <p><strong>Email:</strong> {user.email}</p>
                                                            <p><strong>Teléfono:</strong> {user.phone_number || 'N/A'}</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p><strong>Ubicación:</strong> {user.location || 'N/A'}</p>
                                                            <p><strong>Salario Base:</strong> ${user.salary || 0}</p>
                                                            <p><strong>Comisión General:</strong> {user.commission || 0}%</p>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <p><strong>Fecha de Nacimiento:</strong> {user.dob || 'N/A'}</p>
                                                            <p><strong>Fecha de Creación:</strong> {user.created || 'N/A'}</p>
                                                            <p><strong>Última Actualización:</strong> {user.updated || 'N/A'}</p>
                                                        </div>
                                                    </div>

                                                    {user.roles && user.roles.length > 0 && (
                                                        <>
                                                            <h6>Roles y Comisiones</h6>
                                                            <Accordion>
                                                                {user.roles.map((role, roleIndex) => (
                                                                    <Accordion.Item
                                                                        eventKey={roleIndex.toString()}
                                                                        key={`${user.id}-role-${roleIndex}`}
                                                                    >
                                                                        <Accordion.Header>
                                                                            <div className="d-flex justify-content-between w-100 me-3">
                                                                                <span><strong>{role.title}</strong></span>
                                                                                <Badge bg="success">{role.commission || 0}% Comisión</Badge>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                        <Accordion.Body>
                                                                            <Card className="border-0 bg-white">
                                                                                <Card.Body className="py-3">
                                                                                    <Row>
                                                                                        <Col md={6}>
                                                                                            <div className="mb-2">
                                                                                                <h6 className="mb-1 text-primary">Información del Rol</h6>
                                                                                                <p className="mb-1"><strong>Título:</strong> {role.title}</p>
                                                                                                <p className="mb-1"><strong>Descripción:</strong> {role.description || 'Sin descripción'}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col md={6}>
                                                                                            <div className="mb-2">
                                                                                                <h6 className="mb-1 text-success">Comisión</h6>
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <Icon.DollarSign size={20} className="text-success me-2" />
                                                                                                    <span className="fs-4 fw-bold">{role.commission || 0}%</span>
                                                                                                </div>
                                                                                                <p className="text-muted small mb-0">
                                                                                                    Comisión específica para este rol
                                                                                                </p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                ))}
                                                            </Accordion>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="text-muted small">
                                Mostrando {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, data.length)} de {data.length} entradas
                            </div>
                            <Pagination className="mb-0">
                                <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                />
                                {getPaginationItems()}
                                <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                />
                            </Pagination>
                        </div>
                    )}
                </div>
            </div>
            <DeactivateConfirmModal
                show={Boolean(userToDeactivate)}
                title="Desactivar Usuario"
                itemLabel={userToDeactivate ? `${userToDeactivate.first_name} ${userToDeactivate.last_name}` : ''}
                confirming={deactivatingUser}
                onCancel={() => !deactivatingUser && setUserToDeactivate(null)}
                onConfirm={() => deleteUser(userToDeactivate)}
            />
            </>
        );
}

export default NewUsers;
